import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ResidentReports from './index.vue';

const MOUNT_ID = 'residentReportsTableApp';

let residentReportsApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

export function initResidentReports(root?: ParentNode): void {
  const mountEl = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (!mountEl) {
    return;
  }

  if (residentReportsApp && currentMountEl) {
    residentReportsApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ResidentReports);

  app.use(AntDesignVue).mount(mountEl);

  residentReportsApp = app;
  currentMountEl = mountEl;
}
